import { bugtracker } from '@99designs/design-services-common';
import { StructuredBriefFile } from '@99designs/graph-utils/types';

export interface UploadingFile {
    key: string;
    file: File;
}

export interface FileState {
    uploadingFiles: UploadingFile[];
    uploadedFiles: StructuredBriefFile[];
    error: string | null;
}

type FileAction =
    | { type: 'START_UPLOAD'; payload: { files: UploadingFile[]; isSingleFileOnly?: boolean } }
    | {
          type: 'COMPLETE_UPLOAD';
          payload: { keys: string[]; files: StructuredBriefFile[]; isSingleFileOnly?: boolean };
      }
    | { type: 'START_DELETE'; payload: { key: string } }
    | { type: 'COMPLETE_DELETE'; payload: { key: string } }
    | { type: 'SET_ERROR'; payload: string }
    | { type: 'CLEAR_ERROR' };

export function fileReducer(state: FileState, action: FileAction): FileState {
    // A new operation will clear the error; it's no longer relevant to the current user action.

    switch (action.type) {
        case 'START_UPLOAD':
            return {
                ...state,
                uploadedFiles: action.payload.isSingleFileOnly ? [] : state.uploadedFiles,
                uploadingFiles: [
                    ...(action.payload.isSingleFileOnly ? [] : state.uploadingFiles),
                    ...action.payload.files,
                ],
                error: null,
            };
        case 'COMPLETE_UPLOAD':
            return {
                ...state,
                uploadingFiles: action.payload.isSingleFileOnly
                    ? []
                    : state.uploadingFiles.filter(
                          (uploadingFile) => !action.payload.keys.includes(uploadingFile.key)
                      ),
                uploadedFiles: [
                    ...(action.payload.isSingleFileOnly ? [] : state.uploadedFiles),
                    ...action.payload.files.filter(
                        (file) =>
                            // Prevent uploading the same file more than once.

                            !state.uploadedFiles
                                .map((existingFile) => existingFile.key)
                                .includes(file.key)
                    ),
                ],
            };
        case 'START_DELETE':
            return {
                ...state,
                error: null,
            };
        case 'COMPLETE_DELETE':
            return {
                ...state,
                uploadedFiles: state.uploadedFiles.filter(
                    (file) => file.key !== action.payload.key
                ),
            };
        case 'SET_ERROR':
            return { ...state, error: action.payload };
        case 'CLEAR_ERROR':
            return { ...state, error: null };
        default:
            bugtracker.notify(
                new Error('somehow reached unreachable code; unknown action type in fileReducer')
            );

            return state;
    }
}
